import { render } from "./delete-saved-reply-modal.vue?vue&type=template&id=2e520924&scoped=true"
import script from "./delete-saved-reply-modal.vue?vue&type=script&lang=js"
export * from "./delete-saved-reply-modal.vue?vue&type=script&lang=js"

import "./delete-saved-reply-modal.vue?vue&type=style&index=0&id=2e520924&lang=scss&scoped=true"
import "./delete-saved-reply-modal.vue?vue&type=style&index=1&id=2e520924&lang=scss&scoped=true"
import "./delete-saved-reply-modal.vue?vue&type=style&index=2&id=2e520924&lang=scss&scoped=true"
import "./delete-saved-reply-modal.vue?vue&type=style&index=3&id=2e520924&lang=scss&scoped=true"

import exportComponent from "/Users/girgisnabil/Documents/projects/home-food-plus-full-stack/source/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e520924"]])

export default __exports__